<script>
  export let id = null;
  export let value = null;
  export let icon = null;
  export let placeholder = null;
</script>

<div class="flex flex-nowrap">
  <div class="relative">
    <input
      {id}
      bind:value
      on:input
      {placeholder}
      class="pl-4 pr-8 py-2 bg-white appearance-none rounded-none border border-grey-500"
    />
  </div>
  {#if icon}
    <div class="bg-gray-200 icon">
      <img src={icon} alt="" />
    </div>
  {/if}
</div>

<style>
  .icon {
    height: 42px;
    width: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
